import JWT from 'jsonwebtoken'

const getUser = () => {
    let responseJWT = localStorage.getItem("key");
    let jwtResult = JWT.decode(responseJWT);
    if (!jwtResult) return "";
    return jwtResult.iss;
}
const setUser = (responseJWT) => {
    localStorage.setItem("key", responseJWT);
}

const isValidSession = () => {
    let key = localStorage.getItem("key");
    return (key && key !== '' && 0 !== key.length);
}

export {
    getUser,
    setUser,
    isValidSession
}